const calculateAge = (birthDate: string, otherDate: string | Date): number => {
	const birthday = new Date(birthDate);
	const ageDifMs = new Date(otherDate).getTime() - birthday.getTime();
	const ageDate = new Date(ageDifMs); // miliseconds from epoch
	return Math.abs(ageDate.getUTCFullYear() - 1970);
	// const _birthDate = new Date(birthDate);
	// const _otherDate = new Date(otherDate);

	// let years = _otherDate.getFullYear() - _birthDate.getFullYear();

	// if (
	// 	_otherDate.getMonth() < _birthDate.getMonth() ||
	// 	(_otherDate.getMonth() == _birthDate.getMonth() && _otherDate.getDate() < _birthDate.getDate())
	// ) {
	// 	years--;
	// }

	// return years;
};

export const getAgeInDays = (dateOfBirth: string) => {
	const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
	const firstDate = new Date(dateOfBirth);
	const secondDate = new Date("2025-03-01");

	const diffDays = Math.round(
		Math.abs(((firstDate as unknown as number) - (secondDate as unknown as number)) / oneDay)
	);
	return diffDays;
};

export default calculateAge;
